export default "__VITE_ASSET__CI5Ez_zM__"